import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DischargeDate(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [ipviewData, setIpViewData] = useState([]);
  const [typeData, setTypeData] = useState({ type: '' });

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchIpViewData();
      const intervalId = setInterval(fetchIpViewData, 5000);
      return () => clearInterval(intervalId);
  }, [startDate, endDate, typeData]);

  async function fetchIpViewData() {
    try {
      const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
      const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
      const url = `${baseUrl}ip-discharge-view/?start_date=${startDateString}&end_date=${endDateString}&status=3&type=${typeData.type}`;
      const response = await axios.get(url);
      setIpViewData(response.data);
    } catch (error) {
        console.log(error);
    }
  }

    const columns = [
        {field:'ip_id', headerName:'IP ID',
          renderCell: (params) => (
              <Link to={`/ip-pat-view/${params.row.id}/`}>
                {params.value}
              </Link>
          ),
          width: 100,
          },
        {field:'pat__pat_id', headerName:'Pat Id', width:40},
        {field:'pat__patient', headerName:'Patient', width:150},
        {field:'pat__age', headerName:'Age', width:10},
        {field:'pat__mobile', headerName:'Mobile', width:100},
        {field:'pat__address1', headerName:'Address', width:220},

        {field:'room_no__room_no', headerName:'Room No', width:75},
        {field:'payment', headerName:'Payment', width:100},
         { field: 'admit_date', headerName: 'Admitted On', width: 150,
    renderCell: (params) => (
      <span>{formatDateTime(params.value)}</span>
    ),
  },
        {field:'discharge_time', headerName:'Discharged On', width:120},
        { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link to={`/discharge-notes/${params.row.id}/`} className="btn btn-success">
                Notes
              </Link>
          ),
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
        { field: 'summary', headerName: 'Action',
          renderCell: (params) => (
              <Link to={`/discharge-summary/${params.row.id}/`} className="btn btn-warning">
                Summary
              </Link>
          ),
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];

    const handleUser = (event) => {
      setTypeData({
        ...typeData,
        type: event.target.value
      });
    };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Discharge List Date-wise</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="type" className="form-label">Search by Discharge Type</label>
              <select name="type" id="type" value={typeData.type} className="form-control"
                onChange={(event) => handleUser(event)}>
                  <option value="">Select Discharge Type</option>
                  <option value="Regular">Regular</option>
                  <option value="Death">Death</option>
                  <option value="Against medical">Against Medical Advice</option>
                  <option value="Absconding">Absconding</option>
                  <option value="Emergency">Emergency Discharge</option>
            </select>
            </div>
          </div>
        </div>
      </div>

      {ipviewData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Discharge List </h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={ipviewData}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default DischargeDate;
